module.exports = __webpack_public_path__ + "img/chrome-1.748daa3d.webp";